import { render, staticRenderFns } from "./CategoryEditForm.vue?vue&type=template&id=0ba0bfba&lang=html&"
import script from "./CategoryEditForm.vue?vue&type=script&lang=js&"
export * from "./CategoryEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports